import { ReservationSlice, SliceState } from './types'

export const createReservationSlice: SliceState<ReservationSlice> = (set) => ({
	reservation: {},
	setReservationId: (id: string) =>
		set(
			(state) => ({ ...state, reservation: { ...state.reservation, id } }),
			false,
			'setReservationId'
		),
	setNewsletter: (newsletter: boolean) =>
		set(
			(state) => ({ ...state, reservation: { ...state.reservation, newsletter } }),
			false,
			'setNewsletter'
		),
})
